import { UserCircle, ChatCircleText } from '@phosphor-icons/react'
import { RatingStars } from './RatingStars'
import { formatDateBR } from '../lib/date'

export interface ReviewItem {
  id: string
  rating: number
  comment: string | null
  reply_text: string | null
  replied_at: string | null
  created_at: string
  shipper_name: string
  reviewer_name?: string | null
}

interface ReviewListProps {
  items: ReviewItem[]
  loading?: boolean
  renderReplyAction?: (review: ReviewItem) => React.ReactNode
}

export function ReviewList({ items, loading, renderReplyAction }: ReviewListProps) {
  if (loading) {
    return <div className="py-8 text-center text-sm text-gray-500">Carregando avaliações...</div>
  }
  if (!items.length) {
    return (
      <div className="py-10 text-center text-sm text-gray-500 bg-gray-50 rounded-lg">
        Nenhuma avaliação ainda.
      </div>
    )
  }
  return (
    <div className="divide-y divide-gray-100">
      {items.map((r) => (
        <div key={r.id} className="py-4">
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
              <UserCircle size={28} className="text-emerald-600" weight="duotone" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-medium text-sm text-gray-900">{r.shipper_name}</span>
                <RatingStars value={r.rating} size={14} />
                <span className="text-xs text-gray-400">{formatDateBR(r.created_at)}</span>
              </div>
              {r.comment && (
                <p className="mt-1 text-sm text-gray-700 whitespace-pre-wrap">{r.comment}</p>
              )}
              {r.reply_text ? (
                <div className="mt-3 ml-4 pl-3 border-l-2 border-emerald-200 bg-emerald-50/50 p-3 rounded">
                  <div className="flex items-center gap-2 text-xs text-emerald-700 font-medium mb-1">
                    <ChatCircleText size={14} weight="fill" />
                    Resposta do agente
                    {r.replied_at && (
                      <span className="text-gray-400 font-normal">• {formatDateBR(r.replied_at)}</span>
                    )}
                  </div>
                  <p className="text-sm text-gray-700 whitespace-pre-wrap">{r.reply_text}</p>
                </div>
              ) : (
                renderReplyAction && <div className="mt-2">{renderReplyAction(r)}</div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
